const messages = {
    root: {
        menuTitle: 'Raporty & Analizy',
        pageTitle: 'Raporty & Analizy'
    },
    prepress: {
        menuTitle: 'Prepress',
        pageTitle: 'Raporty & Analizy / Prepress',
        notifications: {
            reportSent: 'Raport został wysłany na adres {userEmail}.'
        },
        common: {
            backToList: 'Powrót do listy',
            actions: {
                search: 'Szukaj'
            },
            filters: {
                from: 'Od',
                to: 'Do'
            },
            placeholders: {
                none: 'brak'
            },
            pdf: {
                generatedAt: 'Wygenerowano: {date}'
            }
        },
        menu: {
            title: 'Prepress',
            actions: {
                open: 'Otwórz'
            },
            cards: {
                plates: {
                    title: 'Raport wykonanych płyt',
                    description: 'Raport wykonanych płyt'
                },
                additionalPlates: {
                    title: 'Raport płyt dodatkowych',
                    description: 'Raport płyt dodatkowych'
                }
            }
        },
        reportPlates: {
            pageTitle: 'Raporty & Analizy / Raport wykonanych płyt',
            title: 'Raport wykonanych płyt',
            actions: {
                generateExcel: 'Generuj raport szczegółowy',
                generatePdf: 'Generuj raport'
            },
            tooltips: {
                refreshChart: 'Odśwież dane na wykresie'
            },
            pdf: {
                title: 'Raport płyt wykonanych w dniach {dates}',
                titleNoDates: 'Raport wykonanych płyt'
            },
            errors: {
                fetchTotalPlates: 'Pobranie ilości płyt wykonanych nie powiodło się.',
                generateExcel: 'Generowanie raportu Excel nie powiodło się.'
            }
        },
        reportAdditionalPlates: {
            pageTitle: 'Raporty & Analizy / Płyty dodatkowe',
            title: 'Raport płyt dodatkowych',
            tabs: {
                shifts: 'ZMIANY',
                creators: 'ZGŁASZAJĄCY',
                checkedBy: 'WYKONUJĄCY'
            },
            labels: {
                shifts: {
                    day: 'od 7 do 19',
                    night: 'od 19 do 7'
                }
            },
            actions: {
                downloadReport: 'Pobierz raport',
                generatePrint: 'Generuj wydruk'
            },
            tooltips: {
                refreshChart: 'Wymagane odświeżenie danych na wykresie'
            },
            pdf: {
                title: 'Płyty dodatkowe zaraportowane w dniach {dates}\n- widok {view}',
                titleNoDates: 'Płyty dodatkowe\n- widok {view}'
            },
            errors: {
                fetchAdditionalPlates: 'Pobranie danych raportu płyt dodatkowych nie powiodło się.'
            }
        }
    },
    orders: {
        menuTitle: 'Zamówienia',
        pageTitle: 'Raporty & Analizy / Zamówienia',
        notifications: {
            reportSent: 'Raport został wysłany na adres {userEmail}.',
            reportWillBeSent: 'Raport zostanie wysłany na adres {userEmail}.'
        },
        common: {
            backToList: 'Powrót do listy',
            actions: {
                search: 'Szukaj',
                generateReport: 'Generuj raport',
                close: 'Zamknij'
            },
            filters: {
                from: 'Od',
                to: 'Do'
            },
            pdf: {
                generatedAt: 'Wygenerowano: {date}'
            },
            baselineLabel: 'Linia bazowa'
        },
        menu: {
            title: 'Zamówienia',
            actions: {
                open: 'Otwórz'
            },
            cards: {
                sentOrders: {
                    title: 'Zamówienia nadane w czasie',
                    description: 'Zamówienia nadane w rozkładzie zmianowym i godzinowym.'
                },
                placedOrders: {
                    title: 'Zamówienia - realizacja na dzień',
                    description: 'Zamówienia zrealizowane w rozkładzie dziennym.'
                },
                weeklySentOrders: {
                    title: 'Średnia ilość zamówień nadanych w rozkładzie tygodniowym',
                    description: 'Zamówienia nadane w rozkładzie godzinowym.'
                },
                monthlySentOrders: {
                    title: 'Średnia ilość zamówień nadanych w rozkładzie miesięcznym',
                    description: 'Zamówienia nadane w rozkładzie godzinowym.'
                },
                orderRealizationReport: {
                    title: 'Raport realizacji zamówienia',
                    description: 'Raport pokazujący przebieg prac nad zamówieniem'
                },
                ordersInProgress: {
                    title: 'Raport - produkcja w toku',
                    description:
                        'Zamówienia, dla których surowiec został wystawiony w jednym miesiącu a ich wysyłka nastąpiła w kolejnym'
                },
                sentOrdersSimple: {
                    title: 'Zamówienia nadane w czasie - wersja prosta',
                    description: 'Zamówienia nadane w rozkładzie zmianowym i godzinowym.'
                }
            }
        },
        orderStatusesReport: {
            title: 'Raport statusów zamówień',
            description: 'Report statusów zamówień filtrowanych po planowanej dacie wysyłki.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        lieferscheinReport: {
            title: 'Raport wydruku Lieferschein',
            description: 'Wydruki Lieferschein, filtrowane po dacie wygenerowania.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        sentOrdersWithWeightReport: {
            title: 'Raport nadanych zamówień z wagą',
            description: 'Historia nadań z danymi o zamówieniu, kurierze, numerze listu, wadze i osobie nadającej.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        orderRealizationReport: {
            dialog: {
                title: 'Raport realizacji zamówienia',
                searchLabel: 'Numer zamówienia',
                hintMinChars: 'Proszę wpisać minimum {count} znaki',
                actions: {
                    generatePdf: 'Generuj raport'
                },
                table: {
                    productionNumber: 'Numer zamówienia',
                    actions: 'Akcje'
                }
            },
            errors: {
                search: 'Szukanie zamówień nie powiodło się.',
                print: 'Wygenerowanie raportu dla podanego numeru zamówienia nie powiodło się.'
            }
        },
        sentOrders: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Zamówienia nadane',
            title: 'Zamówienia nadane w czasie',
            filters: {
                reportType: {
                    label: 'Rodzaj wykresu',
                    noData: 'Nie znaleziono rodzaju',
                    items: {
                        hourly: 'godzinowy',
                        shift: 'zmianowy'
                    }
                },
                product: {
                    label: 'Produkt',
                    noData: 'Nie znaleziono produktów'
                },
                date: {
                    label: 'Data'
                }
            },
            actions: {
                generatePdf: 'Generuj raport'
            },
            tooltips: {
                refreshChart: 'Odśwież dane na wykresie'
            },
            chart: {
                datasetLabel: 'Ilość zamówień',
                tooltipFooter: 'Łączny nakład: {quantity}'
            },
            pdf: {
                title: 'Zamówienia nadane dnia {date}{productSubTitle}',
                productSubtitle: ' - produkt: {productName}',
                allProductsSubtitle: ' - wszystkie produkty'
            },
            errors: {
                fetch: 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.',
                fetchProducts: 'Pobranie produktów nie powiodło się.'
            }
        },
        sentOrdersSimple: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Zamówienia nadane',
            title: 'Zamówienia nadane w czasie',
            chart: {
                datasetLabel: 'Ilość zamówień'
            }
        },
        placedOrders: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (d)',
            title: 'Zamówienia - realizacja na dzień',
            filters: {
                month: {
                    label: 'Data'
                }
            },
            actions: {
                generatePdf: 'Generuj raport'
            },
            chart: {
                axisY: 'Liczba zamówień',
                axisX: 'Dni miesiąca',
                series: {
                    online: 'Online',
                    wmd: 'WMD',
                    offline: 'Offline'
                }
            },
            pdf: {
                title: 'Zamówienia - realizacja na dzień w miesiącu: {month}'
            },
            errors: {
                fetch: 'Pobranie informacji o złożonych zamówieniach nie powiodło się.'
            }
        },
        weeklySentOrders: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (w)',
            title: 'Zamówienia nadane w czasie - realizacja na tydzień',
            filters: {
                date: {
                    label: 'Data'
                }
            },
            actions: {
                generatePdf: 'Generuj raport'
            },
            chart: {
                datasetLabel: 'Średnia ilość zamówień'
            },
            pdf: {
                title: 'Średnia nadań w godzinach na wybrany tydzień: {start} - {end}'
            },
            errors: {
                fetch: 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.'
            }
        },
        monthlySentOrders: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (m)',
            title: 'Zamówienia nadane w czasie - realizacja na miesiąc',
            filters: {
                month: {
                    label: 'Data'
                }
            },
            actions: {
                generatePdf: 'Generuj raport'
            },
            chart: {
                datasetLabel: 'Średnia ilość zamówień'
            },
            pdf: {
                title: 'Średnia nadań w godzinach na wybrany miesiąc: {month}'
            },
            errors: {
                fetch: 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.'
            }
        },
        ordersInProgress: {
            pageTitle: 'Raporty & Analizy / Zamówienia / Produkcja w toku',
            title: 'Produkcja w toku',
            actions: {
                generateReport: 'Generuj raport'
            },
            table: {
                headers: {
                    orderNumber: 'Numer zamówienia',
                    warehouseDate: 'Data pobrania papieru',
                    amount: 'Ilość'
                }
            },
            errors: {
                fetch: 'Pobranie informacji o zamówieniach w toku nie powiodło się.',
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        }
    },
    jobs: {
        menuTitle: 'Zlecenia',
        pageTitle: 'Raporty & Analizy / Zlecenia',
        notifications: {
            reportSent: 'Raport został wysłany na adres {userEmail}.',
            reportWillBeSent: 'Raport zostanie wysłany na adres {userEmail}.'
        },
        common: {
            backToList: 'Powrót do listy',
            actions: {
                open: 'Otwórz',
                generateReport: 'Generuj raport'
            },
            filters: {
                from: 'Od',
                to: 'Do'
            }
        },
        menu: {
            title: 'Zlecenia',
            cards: {
                ncfJobs: {
                    title: 'Zlecenia NCF',
                    description: 'Raport zleceń NCF'
                }
            }
        },
        ncfJobs: {
            pageTitle: 'Raporty & Analizy / Zlecenia / Zlecenia NCF',
            title: 'Zlecenia NCF',
            filters: {
                date: {
                    label: 'Data'
                }
            },
            table: {
                headers: {
                    jobNumber: 'Numer zlecenia',
                    ordinalNumber: 'Numer montażu',
                    createdAt: 'Data utworzenia'
                }
            },
            errors: {
                fetch: 'Pobranie zleceń NCF nie powiodło się.',
                generateReport: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        jobProductsReport: {
            title: 'Raport produktów zleceń',
            description: 'Report produktów zleceń filtrowanych po dacie utworzenia.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        jobPartsReport: {
            title: 'Raport użytków w zleceniach',
            description: 'Report użytków w zleceniach filtrowanych po dacie utworzenia.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        }
    },
    reports: {
        menuTitle: 'Czas pracy',
        pageTitle: 'Raporty & Analizy / Czas pracy',
        notifications: {
            reportSent: 'Raport został wysłany na adres {userEmail}.',
            reportApproved: 'Raport został zatwierdzony.'
        },
        common: {
            backToList: 'Powrót do listy',
            actions: {
                generateReport: 'Generuj raport'
            },
            filters: {
                date: {
                    label: 'Data'
                }
            }
        },
        menu: {
            title: 'Czas pracy',
            actions: {
                open: 'Otwórz'
            },
            cards: {
                dailyShiftSummaries: {
                    title: 'Rozliczenia czasu pracy',
                    description: 'Lista rozliczenia czasu pracy.'
                },
                usersRanking: {
                    title: 'Rankingi',
                    description: 'Lista rankingów.'
                },
                reportsSummaries: {
                    title: 'Podsumowania / Raporty',
                    description: 'Lista raportów.'
                }
            }
        },
        charts: {
            datasetLabel: 'Zadania'
        },
        dailyShiftSummaries: {
            pageTitle: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy',
            title: 'Rozliczenia czasu pracy',
            actions: {
                approve: 'Zatwierdź',
                details: 'Szczegóły raportu',
                tempDetailsUnavailable: 'Szczegóły raportu będą dostępne po migracji modułu Raportowanie.'
            },
            filters: {
                search: {
                    label: 'Szukaj...'
                },
                user: {
                    label: 'Użytkownik',
                    prompt: 'Wpisz treść aby odnaleźć użytkownika.',
                    searching: 'Trwa wyszukiwanie...',
                    noData: 'Nie znaleziono'
                },
                group: {
                    label: 'Grupa',
                    noData: 'Nie znaleziono grupy',
                    items: {
                        bindery: 'Introligatornia',
                        shipping: 'Spedycja'
                    }
                }
            },
            table: {
                headers: {
                    user: 'Pracownik',
                    machines: 'Maszyna',
                    start: 'Start',
                    stop: 'Stop',
                    shippedBoxes: 'Ilość kartonów',
                    shippedWeight: 'Waga sumaryczna',
                    reportedAmount: 'Nakład',
                    finishedReports: 'Suma zadań',
                    efficiency: 'Sprawność',
                    reportedTime: 'Zaraportowano',
                    status: 'Status',
                    actions: 'Akcje'
                }
            },
            approveDialog: {
                title: 'Zatwierdzenie raportu',
                summary: {
                    start: 'Start:',
                    stop: 'Stop:',
                    reported: 'Zaraportowano:'
                },
                metrics: {
                    user: 'Pracownik:',
                    totalAmount: 'Łączny nakład:',
                    totalTasks: 'Suma zadań:',
                    finishedOrders: 'Ilość zaraportowanych zamówień:',
                    averagePeople: 'Średnia ilość osób:',
                    planResult: 'Końcowy wynik wykonania planu:'
                },
                actions: {
                    finish: 'Zakończ'
                }
            },
            detailed: {
                pageTitle: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe',
                title: 'Rozliczenia czasu pracy / Raporty szczegółowe',
                summary: {
                    start: 'Start:',
                    stop: 'Stop:',
                    reported: 'Zaraportowano:'
                },
                metrics: {
                    user: 'Pracownik:',
                    totalAmount: 'Łączny nakład:',
                    totalTasks: 'Suma zadań:',
                    finishedOrders: 'Ilość zaraportowanych zamówień:',
                    averagePeople: 'Średnia ilość osób:',
                    planResult: 'Końcowy wynik wykonania planu:'
                },
                filters: {
                    search: {
                        label: 'Szukaj...'
                    }
                },
                table: {
                    headers: {
                        objectNumber: 'Numer',
                        machine: 'Maszyna',
                        process: 'Proces',
                        plateNumber: 'Montaż',
                        reportAmount: 'Nakład wykonany',
                        people: 'Ilość osób',
                        status: 'Status',
                        start: 'Data rozpoczęcia',
                        finish: 'Data zakończenia',
                        duration: 'Czas trwania',
                        actions: 'Akcje'
                    }
                },
                report: {
                    pageTitle: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe / Raport'
                },
                errors: {
                    fetchSummary: 'Pobranie danych do raportu zbiorczego nie powiodło się.',
                    fetchReports: 'Pobranie listy raportów nie powiodło się.',
                    fetchStatuses: 'Pobranie nazw statusów nie powiodło się.'
                }
            },
            detailedShipments: {
                pageTitle: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe',
                title: 'Zatwierdzanie raportów / Raporty szczegółowe',
                filters: {
                    search: {
                        label: 'Szukaj...'
                    }
                },
                table: {
                    headers: {
                        orderNumber: 'Numer',
                        user: 'Użytkownik',
                        shippedBoxes: 'Ilość kartonów',
                        shippedWeight: 'Waga sumaryczna',
                        start: 'Data rozpoczęcia',
                        finish: 'Data zakończenia',
                        duration: 'Czas trwania',
                        actions: 'Akcje'
                    }
                },
                report: {
                    pageTitle: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe / Raport'
                },
                errors: {
                    fetchReports: 'Pobranie raportów nie powiodło się.'
                }
            },
            errors: {
                fetch: 'Pobranie raportów zbiorczych nie powiodło się.',
                approve: 'Zatwierdzenie raportu nie powiodło się.',
                generateReport: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        usersRanking: {
            pageTitle: 'Raporty & Analizy / Czas pracy / Rankingi',
            title: 'Rankingi',
            filters: {
                type: {
                    label: 'Typ rankingu',
                    noData: 'Nie znaleziono typu rankingu'
                },
                group: {
                    label: 'Grupa procesu',
                    noData: 'Nie znaleziono grupy procesu'
                },
                month: {
                    label: 'Data'
                }
            },
            table: {
                headers: {
                    user: 'Pracownik',
                    score: 'Punkty',
                    start: 'Data rozpoczęcia',
                    finish: 'Data zakończenia'
                }
            },
            errors: {
                fetchTypes: 'Pobranie rodzajów rankingów nie powiodło się.',
                fetchGroups: 'Pobranie grup procesów nie powiodło się.',
                fetch: 'Pobranie raportów zbiorczych nie powiodło się.',
                generateReport: 'Wygenerowanie raportu nie powiodło się.'
            }
        },
        reportsSummaries: {
            pageTitle: 'Raporty & Analizy / Czas pracy / Podsumowania / Raporty',
            title: 'Lista raportów',
            filters: {
                users: {
                    label: 'Operatorzy',
                    prompt: 'Wpisz treść aby odnaleźć operatora.',
                    searching: 'Trwa wyszukiwanie...',
                    noData: 'Nie znaleziono'
                },
                productionSite: {
                    label: 'Stanowisko',
                    noData: 'Nie znaleziono typu stanowiska'
                },
                productionSiteGroup: {
                    label: 'Grupa stanowisk',
                    noData: 'Nie znaleziono grupy stanowisk'
                },
                date: {
                    label: 'Data'
                }
            },
            table: {
                headers: {
                    user: 'Pracownik',
                    efficiency: 'Wydajność',
                    timeWorked: 'Suma czasu',
                    doneAmount: 'Suma nakładu'
                }
            },
            errors: {
                fetch: 'Pobranie podsumowań nie powiodło się.',
                generateReport: 'Wygenerowanie raportu nie powiodło się.'
            }
        }
    },
    fvFromXL: {
        menuTitle: 'FV z XL',
        pageTitle: 'Raporty & Analizy / FV z XL',
        title: 'FV z XL',
        filters: {
            clear: 'Resetuj filtry',
            number: 'Numer zlecenia',
            sentToXL: 'Wysłane do XL',
            customerName: 'Klient',
            invoiceNumber: 'Numer FV',
            createdAtFrom: 'Data utworzenia od',
            createdAtTo: 'Data utworzenia do'
        },
        table: {
            headers: {
                number: 'Numer zlecenia',
                sentToXL: 'Wysłane do XL',
                customerName: 'Klient',
                createdAt: 'Data utworzenia',
                invoiceNumber: 'Numer FV',
                netSalesValue: 'Wartość netto sprzedaży',
                actions: 'Akcje'
            }
        },
        actions: {
            refresh: 'Odśwież'
        },
        notifications: {
            refreshSuccess: 'Lista faktur dla pozycji została odświeżona',
            refreshError: 'Nie udało się odświeżyć listy faktur dla pozycji'
        },
        errors: {
            fetch: 'Pobranie danych FV z XL nie powiodło się.'
        }
    },
    cooperationPaper: {
        menuTitle: 'Papier w kooperacji',
        pageTitle: 'Raporty & Analizy / Papier w kooperacji',
        title: 'Papier w kooperacji',
        notifications: {
            reportWillBeSent: 'Raport zostanie wysłany na adres {userEmail}.'
        },
        actions: {
            generateReport: 'Generuj raport'
        },
        filters: {
            from: 'Od',
            to: 'Do'
        },
        errors: {
            invalidDateRange: 'Nieprawidłowy zakres dat.'
        },
        paperConsumptionReport: {
            title: 'Raport zużycia papieru w kooperacji',
            description:
                'Raport planowanego i faktycznego zużycia papieru w zleceniach kooperanta STS filtrowanych po dacie utworzenia zlecenia.',
            errors: {
                generate: 'Wygenerowanie raportu nie powiodło się.'
            }
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
